import { getApi, postApi, putApi } from "../apiCall";

export const createListing = (payload, user) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/${user}/create`;
  return postApi(url, payload);
};

export const editListing = (payload, user) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/${user}/update`;
  return putApi(url, payload);
};

export const withdrawListing = (listingId, user) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/${user}/withdraw/${listingId}`;
  return putApi(url);
};

export const holdListing = (listingId, user) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/${user}/hold/${listingId}`;
  return putApi(url, {});
};

export const resumeListing = (listingId, user) => {
  const url = `${process.env.REACT_APP_API_URL}/bsbp/capacity/${user}/unhold/${listingId}`;
  return putApi(url, {});
};

export const placeBidApi = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/bid/create`;
  return postApi(url, payload);
};

export const acceptConnection = (payload, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/bid/approvereject/${id}`;
  return putApi(url, payload);
};

export const handleAcceptT_C = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/acceptTerms`;
  return postApi(url, payload);
};

export const handleInitEditT_C = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/terms`;
  return putApi(url, payload);
};

export const handleRejectAllT_C = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/terms/reject`;
  return postApi(url, payload);
};

export const handleApproveAgreement = (payload) => {
  let url = `${process.env.REACT_APP_API_URL}/bsbp/connection/acceptAgreement`;
  return postApi(url, payload);
};

export const handleUploadDoc = (payload, type, id) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/upload/${type}/BSB/${id}`;
  return postApi(url, payload, { "Content-Type": "multipart/form-data" });
};
